// extracted by mini-css-extract-plugin
module.exports = {"spantext":"calendar-module--spantext--2Y5k-"};